import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './lang/lang'
import store from './store'
import VueCookie from 'vue-cookie'
import MetaInfo from 'vue-meta-info'

// styles
import '@css/reset.css'

import '@font/font.css'

import '@css/layout.sass'

Vue.config.productionTip = false
Vue.use(VueCookie)
Vue.use(MetaInfo)

export const app = new Vue({
  el: '#app',
  store,
  i18n,
  router,
  beforeCreate() {
    //解析head
    let lang = 'hk'
    let default_lang = lang
    if(process.env.NODE_ENV === 'production') {
      var req = new XMLHttpRequest();
      req.open('GET', document.location, false);
      req.send(null);
      let serveLangx = req.getResponseHeader('HTTP_REAL_SRC_COUNTRY') ? req.getResponseHeader('HTTP_REAL_SRC_COUNTRY').toLowerCase() : lang
      switch(serveLangx){
        case 'hk': case 'tw':
          lang = 'hk'
          break
        case 'cn':
          lang = 'cn'
          break
        case 'kr':
          lang = 'kr'
          break
        case 'vn':
          lang = 'vn'
          break
        case 'th':
          lang = 'th'
          break
        case 'jp':
          lang = 'jp'
          break
        default:
          lang = 'en'
          break
      }
      default_lang = req.getResponseHeader('HTTP_REAL_SRC_COUNTRY') ? lang : 'cn'
    }
    //判斷有無cookie
    if(!this.$cookie.get('rollingbet')){
      this.$cookie.set('rollingbet',lang,3);
    }else{
      lang = this.$cookie.get('rollingbet');
      this.$cookie.set('rollingbet',lang,3);
    }

    //語系init
    i18n.locale = lang

    this.$store.dispatch('setInitLang',{
      'default':default_lang,
      'custom':lang
    })
  },
  metaInfo() {
    return{
      title: this.$i18n.t('lang_index_title'),
      meta: [
        {
          name: 'keyWords',
          content: this.$i18n.t('lang_index_SEO_1')
        },{
          name: 'description',
          content: this.$i18n.t('lang_index_SEO_2')
        }
      ]
    }
  },
  render: h => h(App)
})